/**
 * @generated SignedSource<<f17061b93090b9d836a3dbda28d0c601>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgeRange = "LT12" | "GT12LT19" | "GT20LT24" | "GT25LT29" | "GT30LT34" | "GT35LT39" | "GT40LT44" | "GT45LT49" | "GT50LT54" | "GT55LT59" | "%future added value";
export type Browser = "IE" | "CHROME" | "SAFARI" | "FIREFOX" | "EDGE" | "OTHER" | "%future added value";
export type DayOfWeek = "SUN" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SUT" | "%future added value";
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type Gender = "MALE" | "FEMALE" | "%future added value";
export type MatchOp = "EQUAL" | "CONTAINS" | "%future added value";
export type Platform = "IOS" | "WINDOWS" | "ANDROID" | "MAC" | "LINUX" | "OTHER" | "%future added value";
export type VisitMatch = "EQUAL_MATCH_TYPE" | "OVER_MATCH_TYPE" | "UNDER_MATCH_TYPE" | "%future added value";
export type CreateChatbotGroupInput = {
  clientMutationId?: string | null;
  ageRanges?: ReadonlyArray<AgeRange> | null;
  browsers?: ReadonlyArray<Browser> | null;
  deliverDayOfWeeks?: ReadonlyArray<DeliverDayOfWeekInput> | null;
  deliverTargetUrls?: ReadonlyArray<ChatbotGroupDeliverUrlInput> | null;
  deliverExcludeUrls?: ReadonlyArray<ChatbotGroupDeliverUrlInput> | null;
  deliverKind: DeliverKind;
  devices?: ReadonlyArray<Device> | null;
  endDate?: string | null;
  endTime?: string | null;
  excludeHolidays?: boolean | null;
  excludeReferrers: ReadonlyArray<ChatbotGroupExcludeReferrerInput>;
  genders?: ReadonlyArray<Gender> | null;
  name: string;
  pageId: string;
  sourceIds: ReadonlyArray<string>;
  platforms?: ReadonlyArray<Platform> | null;
  referrers: ReadonlyArray<ChatbotGroupReferrerInput>;
  startDate?: string | null;
  startTime?: string | null;
  status?: DistributionStatus | null;
  targetCookies?: ReadonlyArray<ChatbotGroupTargetCookieInput> | null;
  visitCount?: number | null;
  visitMatchType?: VisitMatch | null;
};
export type DeliverDayOfWeekInput = {
  weekOfMonth?: number | null;
  daysOfWeek: ReadonlyArray<DayOfWeek>;
};
export type ChatbotGroupDeliverUrlInput = {
  url: string;
};
export type ChatbotGroupExcludeReferrerInput = {
  referrer: string;
  matchOp: MatchOp;
};
export type ChatbotGroupReferrerInput = {
  referrer: string;
  matchOp: MatchOp;
};
export type ChatbotGroupTargetCookieInput = {
  key: string;
  value: string;
  matchType: boolean;
};
export type ChatbotCreatePageContainer_Mutation$variables = {
  input: CreateChatbotGroupInput;
};
export type ChatbotCreatePageContainer_MutationVariables = ChatbotCreatePageContainer_Mutation$variables;
export type ChatbotCreatePageContainer_Mutation$data = {
  readonly createChatbotGroup: {
    readonly chatbotGroup: {
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly page: {
        readonly id: string;
        readonly funnel: {
          readonly id: string;
        };
      };
      readonly platforms: ReadonlyArray<Platform>;
      readonly browsers: ReadonlyArray<Browser>;
      readonly devices: ReadonlyArray<Device>;
      readonly genders: ReadonlyArray<Gender>;
      readonly ageRanges: ReadonlyArray<AgeRange>;
      readonly deliverKind: DeliverKind;
      readonly repeat: boolean;
      readonly startDate: string | null;
      readonly startTime: string | null;
      readonly endDate: string | null;
      readonly endTime: string | null;
      readonly sources: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly referrers: ReadonlyArray<{
        readonly referrer: string;
        readonly matchOp: MatchOp;
      }>;
      readonly excludeReferrers: ReadonlyArray<{
        readonly referrer: string;
        readonly matchOp: MatchOp;
      }>;
      readonly visitCount: number | null;
      readonly visitMatchType: VisitMatch;
      readonly deliverTargetUrls: ReadonlyArray<{
        readonly url: string;
      }>;
      readonly deliverExcludeUrls: ReadonlyArray<{
        readonly url: string;
      }>;
      readonly targetCookies: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
        readonly matchType: boolean;
      }>;
      readonly deliverDayOfWeeks: ReadonlyArray<{
        readonly weekOfMonth: number | null;
        readonly daysOfWeek: ReadonlyArray<DayOfWeek>;
      }>;
      readonly status: DistributionStatus;
    } | null;
  } | null;
};
export type ChatbotCreatePageContainer_MutationResponse = ChatbotCreatePageContainer_Mutation$data;
export type ChatbotCreatePageContainer_Mutation = {
  variables: ChatbotCreatePageContainer_MutationVariables;
  response: ChatbotCreatePageContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platforms",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browsers",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "devices",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "genders",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ageRanges",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverKind",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repeat",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Source",
  "kind": "LinkedField",
  "name": "sources",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "referrer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchOp",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatbotGroupReferrer",
  "kind": "LinkedField",
  "name": "referrers",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatbotGroupExcludeReferrer",
  "kind": "LinkedField",
  "name": "excludeReferrers",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitCount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitMatchType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v24 = [
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchType",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "DeliverDayOfWeek",
  "kind": "LinkedField",
  "name": "deliverDayOfWeeks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weekOfMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "daysOfWeek",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v30 = [
  (v23/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatbotCreatePageContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateChatbotGroupPayload",
        "kind": "LinkedField",
        "name": "createChatbotGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatbotGroup",
            "kind": "LinkedField",
            "name": "chatbotGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroupDeliverTargetUrl",
                "kind": "LinkedField",
                "name": "deliverTargetUrls",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroupDeliverExcludeUrl",
                "kind": "LinkedField",
                "name": "deliverExcludeUrls",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroupTargetCookie",
                "kind": "LinkedField",
                "name": "targetCookies",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              (v28/*: any*/),
              (v29/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatbotCreatePageContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateChatbotGroupPayload",
        "kind": "LinkedField",
        "name": "createChatbotGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatbotGroup",
            "kind": "LinkedField",
            "name": "chatbotGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroupDeliverTargetUrl",
                "kind": "LinkedField",
                "name": "deliverTargetUrls",
                "plural": true,
                "selections": (v30/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroupDeliverExcludeUrl",
                "kind": "LinkedField",
                "name": "deliverExcludeUrls",
                "plural": true,
                "selections": (v30/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroupTargetCookie",
                "kind": "LinkedField",
                "name": "targetCookies",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v28/*: any*/),
              (v29/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61046cbb74fd0608644842efb7d7cb8a",
    "id": null,
    "metadata": {},
    "name": "ChatbotCreatePageContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ChatbotCreatePageContainer_Mutation(\n  $input: CreateChatbotGroupInput!\n) {\n  createChatbotGroup(input: $input) {\n    chatbotGroup {\n      id\n      name\n      slug\n      page {\n        id\n        funnel {\n          id\n        }\n      }\n      platforms\n      browsers\n      devices\n      genders\n      ageRanges\n      deliverKind\n      repeat\n      startDate\n      startTime\n      endDate\n      endTime\n      sources {\n        id\n        name\n      }\n      referrers {\n        referrer\n        matchOp\n      }\n      excludeReferrers {\n        referrer\n        matchOp\n      }\n      visitCount\n      visitMatchType\n      deliverTargetUrls {\n        url\n        id\n      }\n      deliverExcludeUrls {\n        url\n        id\n      }\n      targetCookies {\n        key\n        value\n        matchType\n        id\n      }\n      deliverDayOfWeeks {\n        weekOfMonth\n        daysOfWeek\n      }\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7690e1eef0e13f0ae7b2ff4bb9f94f5d";

export default node;
